import React from 'react';
import PropTypes from 'prop-types';

import { Company } from 'components/common/Elements/Elements';

const Account = ({ data }) => {
  const {
    customerId,
    companyName,
    status,
    companySize,
    country,
    website,
    customerType
  } = data;

  return (
    <Company
      nameCompany={companyName ? companyName : customerId}
      status={status}
      description={companySize}
      recordType={customerType}
      country={country}
      domain={website}
      customerId={customerId}
    />
  );
};

Account.propTypes = {
  data: PropTypes.object
};

export default Account;
